import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = 'https://cotizaciones-fabrica-rivera-production.up.railway.app/api';
const BASE = 'https://cotizaciones-fabrica-rivera-production.up.railway.app';
const UNIDADES = ['unidad', 'metro lineal', 'metro cuadrado'];

export default function NuevaCotizacion() {
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  const [asesor, setAsesor] = useState('Geyson Rivera');
  const [clientes, setClientes] = useState([]);
  const [productos, setProductos] = useState([]);
  const [clienteId, setClienteId] = useState('');
  const [formaPago, setFormaPago] = useState('CONTADO');
  const [validez, setValidez] = useState('');
  const [tiempoEntrega, setTiempoEntrega] = useState('');
  const [notas, setNotas] = useState('');
  const [condiciones, setCondiciones] = useState('Productos para uso profesional, comercial e institucional. Garantía de 6 meses para equipos manuales y eléctricos.');
  const [descuentoGlobal, setDescuentoGlobal] = useState(0);

  // ── AIU ──
  const [tipoCotizacion, setTipoCotizacion] = useState('NORMAL');
  const [porcAdmin, setPorcAdmin] = useState(15);
  const [porcImprevistos, setPorcImprevistos] = useState(5);
  const [porcUtilidad, setPorcUtilidad] = useState(10);

  // ── IVA general (interruptor a nivel de cotización, independiente del IVA por producto) ──
  const [incluyeIva, setIncluyeIva] = useState(true);

  const [items, setItems] = useState([
    { producto_id:'', nombre:'', caracteristicas:'', cantidad:1, unidad:'unidad', precio_unitario:0, descuento_item:0, aplica_iva:true, imagen_url:null }
  ]);

  useEffect(() => {
    axios.get(`${API}/clientes`, { headers }).then(r => setClientes(r.data));
    axios.get(`${API}/productos`, { headers }).then(r => setProductos(r.data));
  }, []);

  const clienteSeleccionado = clientes.find(c => c.id === clienteId);

  const agregarItem = () => setItems([...items, {
    producto_id:'', nombre:'', caracteristicas:'', cantidad:1, unidad:'unidad', precio_unitario:0, descuento_item:0, aplica_iva:true, imagen_url:null
  }]);

  const eliminarItem = (i) => setItems(items.filter((_, idx) => idx !== i));

  const moverItem = (i, direccion) => {
    const destino = i + direccion;
    if (destino < 0 || destino >= items.length) return;
    const nuevos = [...items];
    [nuevos[i], nuevos[destino]] = [nuevos[destino], nuevos[i]];
    setItems(nuevos);
  };

  const actualizarItem = (i, campo, valor) => {
    const nuevos = [...items];
    nuevos[i][campo] = valor;
    if (campo === 'producto_id') {
      const prod = productos.find(p => p.id === valor);
      if (prod) {
        nuevos[i].nombre = prod.nombre;
        nuevos[i].precio_unitario = prod.precio_base;
        nuevos[i].aplica_iva = prod.aplica_iva;
        nuevos[i].unidad = prod.unidad;
        nuevos[i].imagen_url = prod.imagen_url;
        nuevos[i].caracteristicas = prod.descripcion || '';
      }
    }
    // "unidad" (piezas) debe ser cantidad entera; metro lineal/cuadrado sí admite decimales
    if (nuevos[i].unidad === 'unidad' && (campo === 'cantidad' || campo === 'unidad')) {
      nuevos[i].cantidad = Math.round(parseFloat(nuevos[i].cantidad) || 0);
    }
    setItems(nuevos);
  };

  const calcSubtotalItem = (item) =>
    item.cantidad * item.precio_unitario * (1 - (item.descuento_item || 0) / 100);

  const calcIvaItem = (item) =>
    (incluyeIva && item.aplica_iva) ? calcSubtotalItem(item) * 0.19 : 0;

  const subtotalGeneral = items.reduce((a, i) => a + calcSubtotalItem(i), 0) * (1 - descuentoGlobal / 100);

  // ── Cálculos AIU (en vivo, solo para mostrar antes de guardar) ──
  const valorAdmin = tipoCotizacion === 'AIU' ? subtotalGeneral * (porcAdmin / 100) : 0;
  const valorImprevistos = tipoCotizacion === 'AIU' ? subtotalGeneral * (porcImprevistos / 100) : 0;
  const valorUtilidad = tipoCotizacion === 'AIU' ? subtotalGeneral * (porcUtilidad / 100) : 0;
  const valorAiuTotal = valorAdmin + valorImprevistos + valorUtilidad;

  const ivaGeneral = tipoCotizacion === 'AIU'
    ? (incluyeIva ? valorUtilidad * 0.19 : 0)
    : items.reduce((a, i) => a + calcIvaItem(i), 0) * (1 - descuentoGlobal / 100);

  const totalGeneral = tipoCotizacion === 'AIU'
    ? subtotalGeneral + valorAiuTotal + ivaGeneral
    : subtotalGeneral + ivaGeneral;

  const guardar = async () => {
    if (!clienteId) return alert('Selecciona un cliente');
    if (items.some(i => !i.precio_unitario)) return alert('Completa todos los ítems');
    try {
      const payload = {
        cliente_id: clienteId,
        descuento_global: descuentoGlobal,
        fecha_vencimiento: validez || null,
        notas: `FORMA DE PAGO: ${formaPago}\nTIEMPO DE ENTREGA: ${tiempoEntrega}\nASESOR: ${asesor}\n${notas}`,
        condiciones,
        tipo_cotizacion: tipoCotizacion,
        incluye_iva: incluyeIva,
        porcentaje_administracion: tipoCotizacion === 'AIU' ? porcAdmin : 0,
        porcentaje_imprevistos: tipoCotizacion === 'AIU' ? porcImprevistos : 0,
        porcentaje_utilidad: tipoCotizacion === 'AIU' ? porcUtilidad : 0,
        items: items.map((it, idx) => ({
            producto_id: it.producto_id || null,
            cantidad: parseFloat(it.cantidad),
            precio_unitario: parseFloat(it.precio_unitario),
            descuento_item: parseFloat(it.descuento_item || 0),
            aplica_iva: it.aplica_iva,
            imagen_url: it.imagen_url || null,
            unidad: it.unidad || 'unidad',
            descripcion_libre: `${it.nombre}${it.caracteristicas ? ' - ' + it.caracteristicas : ''}`,
            orden: idx
            }))
      };
      const res = await axios.post(`${API}/cotizaciones`, payload, { headers });
      window.location.href = `/cotizacion/${res.data.id}`;
    } catch (err) {
      const data = err.response?.data;
      if (data?.error === 'descuento_excedido') {
        alert(`⚠️ ${data.mensaje}\n\nAjusta el descuento y luego cambia el estado a "En aprobación" desde la cotización.`);
        return;
      }
      alert('Error al guardar: ' + err.message);
    }
  };

  return (
    <div style={s.page}>
      <div style={s.header} className="rf-header">
        <button style={s.btnVolver} onClick={() => window.location.href='/'}>← Volver</button>
        <h1 style={s.titulo}>Nueva Cotización</h1>
        <button style={s.btnGuardar} onClick={guardar}>Guardar Cotización</button>
      </div>

      <div style={s.container} className="rf-container">
        {/* TIPO DE COTIZACIÓN */}
        <div style={s.card}>
          <h3 style={s.cardTitulo}>Tipo de Cotización</h3>
          <div style={s.tipoSelector}>
            <button
              style={tipoCotizacion === 'NORMAL' ? s.tipoBtnActivo : s.tipoBtn}
              onClick={() => setTipoCotizacion('NORMAL')}>
              Normal
            </button>
            <button
              style={tipoCotizacion === 'AIU' ? s.tipoBtnActivo : s.tipoBtn}
              onClick={() => setTipoCotizacion('AIU')}>
              AIU (Administración, Imprevistos y Utilidad)
            </button>
          </div>

          {tipoCotizacion === 'AIU' && (
            <div style={{...s.grid2, marginTop:'1rem'}} className="rf-grid2">
              <div>
                <label style={s.label}>Administración %</label>
                <input style={s.input} type="number" min="0" max="100"
                  value={porcAdmin} onChange={e => setPorcAdmin(parseFloat(e.target.value) || 0)} />
              </div>
              <div>
                <label style={s.label}>Imprevistos %</label>
                <input style={s.input} type="number" min="0" max="100"
                  value={porcImprevistos} onChange={e => setPorcImprevistos(parseFloat(e.target.value) || 0)} />
              </div>
              <div>
                <label style={s.label}>Utilidad %</label>
                <input style={s.input} type="number" min="0" max="100"
                  value={porcUtilidad} onChange={e => setPorcUtilidad(parseFloat(e.target.value) || 0)} />
              </div>
              <div>
                <label style={s.label}>Total AIU</label>
                <input style={{...s.input, background:'#f5f5f5', fontWeight:'700'}} disabled
                  value={`${(porcAdmin + porcImprevistos + porcUtilidad).toFixed(2)}%`} />
              </div>
            </div>
          )}

          <div style={{ marginTop:'1.5rem', paddingTop:'1rem', borderTop:'1px solid #eee' }}>
            <label style={s.label}>¿Esta cotización incluye IVA (19%)?</label>
            <div style={{ display:'flex', gap:'10px' }}>
              <button type="button"
                style={incluyeIva ? s.tipoBtnActivo : s.tipoBtn}
                onClick={() => setIncluyeIva(true)}>
                Sí, incluir IVA
              </button>
              <button type="button"
                style={!incluyeIva ? s.tipoBtnActivo : s.tipoBtn}
                onClick={() => setIncluyeIva(false)}>
                Sin IVA (exento)
              </button>
            </div>
          </div>
        </div>

        {/* DATOS DEL CLIENTE */}
        <div style={s.card}>
          <h3 style={s.cardTitulo}>Datos del Cliente</h3>
          <div style={s.grid2} className="rf-grid2">
            <div>
              <label style={s.label}>Cliente</label>
              <select style={s.select} value={clienteId} onChange={e => setClienteId(e.target.value)}>
                <option value="">-- Selecciona cliente --</option>
                {clientes.map(c => <option key={c.id} value={c.id}>{c.razon_social}</option>)}
              </select>
            </div>
            <div>
              <label style={s.label}>Forma de pago</label>
              <select style={s.select} value={formaPago} onChange={e => setFormaPago(e.target.value)}>
                <option>CONTADO</option>
                <option>CRÉDITO 30 DÍAS</option>
                <option>CRÉDITO 60 DÍAS</option>
                <option>50% ANTICIPO</option>
              </select>
            </div>
            <div>
              <label style={s.label}>Validez de la oferta hasta</label>
              <input style={s.input} type="date" value={validez} onChange={e => setValidez(e.target.value)} />
            </div>
            <div>
              <label style={s.label}>Tiempo de entrega</label>
              <input style={s.input} type="text" placeholder="Ej: 30 días hábiles"
                value={tiempoEntrega} onChange={e => setTiempoEntrega(e.target.value)} />
            </div>
            <div>
              <label style={s.label}>Asesor Comercial</label>
              <select style={s.select} value={asesor} onChange={e => setAsesor(e.target.value)}>
                <option>Geyson Rivera</option>
                <option>Erika Castro</option>
                <option>Emanuel Rivera</option>
                <option>Angel Rivera</option>
              </select>
            </div>
          </div>
          {clienteSeleccionado && (
            <div style={s.infoCliente}>
              <span>NIT: {clienteSeleccionado.nit}</span>
              <span>Ciudad: {clienteSeleccionado.ciudad}</span>
              <span>Contacto: {clienteSeleccionado.contacto}</span>
            </div>
          )}
        </div>

        {/* TABLA DE ÍTEMS */}
        <div style={s.card}>
          <h3 style={s.cardTitulo}>Ítems de la Cotización</h3>
          <div className="rf-tabla-wrap">
          <table style={{...s.tabla, minWidth:'900px'}}>
            <thead>
              <tr style={s.theadRow}>
                <th style={s.th}>#</th>
                <th style={s.th}>Imagen</th>
                <th style={s.th}>Equipo / Servicio</th>
                <th style={s.th}>Características</th>
                <th style={s.th}>Cant.</th>
                <th style={s.th}>Unidad</th>
                <th style={s.th}>Vr antes IVA</th>
                <th style={s.th}>Desc %</th>
                <th style={s.th}>IVA 19%</th>
                <th style={s.th}>Subtotal</th>
                <th style={s.th}></th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, i) => (
                <tr key={i} style={s.row}>
                  <td style={s.td}>
                    <div style={{ display:'flex', alignItems:'center', gap:'4px' }}>
                      <span>{i + 1}</span>
                      <div style={{ display:'flex', flexDirection:'column' }}>
                        <button type="button" style={s.btnOrden} disabled={i === 0} onClick={() => moverItem(i, -1)} title="Mover arriba">▲</button>
                        <button type="button" style={s.btnOrden} disabled={i === items.length - 1} onClick={() => moverItem(i, 1)} title="Mover abajo">▼</button>
                      </div>
                    </div>
                  </td>
                  <td style={s.td}>
                    {item.imagen_url
                      ? <img src={item.imagen_url?.startsWith('http') ? item.imagen_url : `${BASE}${item.imagen_url}`} alt="" style={s.itemImg} />
                      : <div style={s.sinImg}>—</div>
                    }
                  </td>
                  <td style={s.td}>
                    <select style={s.inputSm} value={item.producto_id}
                      onChange={e => actualizarItem(i, 'producto_id', e.target.value)}>
                      <option value="">-- Producto --</option>
                      {productos.map(p => <option key={p.id} value={p.id}>{p.nombre}</option>)}
                    </select>
                    <input style={{...s.inputSm, marginTop:'4px'}} placeholder="O escribe nombre"
                      value={item.nombre} onChange={e => actualizarItem(i, 'nombre', e.target.value)} />
                  </td>
                  <td style={s.td}>
                    <input style={s.inputSm} placeholder="Especificaciones"
                      value={item.caracteristicas} onChange={e => actualizarItem(i, 'caracteristicas', e.target.value)} />
                  </td>
                  <td style={s.td}>
                    <input style={{...s.inputSm, width:'60px'}} type="number" min="0"
                      step={item.unidad === 'unidad' ? '1' : '0.01'}
                      value={item.cantidad} onChange={e => actualizarItem(i, 'cantidad', e.target.value)} />
                  </td>
                  <td style={s.td}>
                    <select style={{...s.inputSm, width:'120px'}} value={item.unidad}
                      onChange={e => actualizarItem(i, 'unidad', e.target.value)}>
                      {UNIDADES.map(u => <option key={u} value={u}>{u}</option>)}
                    </select>
                  </td>
                  <td style={s.td}>
                    <input style={{...s.inputSm, width:'110px'}} type="number" min="0"
                      value={item.precio_unitario} onChange={e => actualizarItem(i, 'precio_unitario', e.target.value)} />
                  </td>
                  <td style={s.td}>
                    <input style={{...s.inputSm, width:'60px'}} type="number" min="0" max="100"
                      value={item.descuento_item} onChange={e => actualizarItem(i, 'descuento_item', e.target.value)} />
                  </td>
                  <td style={s.td}>$ {Math.round(calcIvaItem(item)).toLocaleString('es-CO')}</td>
                  <td style={s.td}>$ {Math.round(calcSubtotalItem(item)).toLocaleString('es-CO')}</td>
                  <td style={s.td}>
                    <button style={s.btnEliminar} onClick={() => eliminarItem(i)}>✕</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
          <button style={s.btnAgregar} onClick={agregarItem}>+ Agregar ítem</button>
        </div>

        {/* TOTALES Y NOTAS */}
        <div style={s.grid2} className="rf-grid2">
          <div style={s.card}>
            <h3 style={s.cardTitulo}>Observaciones</h3>
            <textarea style={s.textarea} rows="4" value={notas}
              onChange={e => setNotas(e.target.value)} placeholder="Observaciones..." />
            <h3 style={{...s.cardTitulo, marginTop:'1rem'}}>Condiciones generales</h3>
            <textarea style={s.textarea} rows="4" value={condiciones}
              onChange={e => setCondiciones(e.target.value)} />
          </div>
          <div style={s.card}>
            <h3 style={s.cardTitulo}>Resumen</h3>
            <div style={s.totalRow}><span>Subtotal</span><span>$ {Math.round(subtotalGeneral).toLocaleString('es-CO')}</span></div>

            {tipoCotizacion === 'AIU' && (
              <>
                <div style={s.totalRow}><span>Administración ({porcAdmin}%)</span><span>$ {Math.round(valorAdmin).toLocaleString('es-CO')}</span></div>
                <div style={s.totalRow}><span>Imprevistos ({porcImprevistos}%)</span><span>$ {Math.round(valorImprevistos).toLocaleString('es-CO')}</span></div>
                <div style={s.totalRow}><span>Utilidad ({porcUtilidad}%)</span><span>$ {Math.round(valorUtilidad).toLocaleString('es-CO')}</span></div>
                <div style={s.totalRow}><span>IVA sobre Utilidad (19%)</span><span>$ {Math.round(ivaGeneral).toLocaleString('es-CO')}</span></div>
              </>
            )}

            {tipoCotizacion === 'NORMAL' && (
              <div style={s.totalRow}><span>IVA 19%</span><span>$ {Math.round(ivaGeneral).toLocaleString('es-CO')}</span></div>
            )}

            <div style={s.totalRow}>
              <span>Descuento global %</span>
              <input style={{...s.inputSm, width:'70px'}} type="number" min="0" max="100"
                value={descuentoGlobal} onChange={e => setDescuentoGlobal(e.target.value)} />
            </div>
            <div style={s.totalFinal}>
              <span>TOTAL</span>
              <span>$ {Math.round(totalGeneral).toLocaleString('es-CO')}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const s = {
  page:       { minHeight:'100vh', background:'#f5f5f5' },
  header:     { background:'#1a1a2e', padding:'1rem 2rem', display:'flex', justifyContent:'space-between', alignItems:'center' },
  titulo:     { color:'#c8a951', fontSize:'20px', fontWeight:'700' },
  btnVolver:  { background:'transparent', color:'#aaa', border:'1px solid #aaa', padding:'8px 14px', borderRadius:'8px' },
  btnGuardar: { background:'#c8a951', color:'#fff', border:'none', padding:'10px 20px', borderRadius:'8px', fontWeight:'700', fontSize:'15px' },
  container:  { padding:'1.5rem', maxWidth:'1300px', margin:'0 auto' },
  card:       { background:'#fff', borderRadius:'10px', padding:'1.5rem', marginBottom:'1.5rem', boxShadow:'0 2px 8px rgba(0,0,0,0.07)' },
  cardTitulo: { fontSize:'16px', fontWeight:'700', color:'#1a1a2e', marginBottom:'1rem', borderBottom:'2px solid #c8a951', paddingBottom:'6px' },
  grid2:      { display:'grid', gridTemplateColumns:'1fr 1fr', gap:'1.5rem' },
  label:      { display:'block', fontSize:'13px', color:'#666', marginBottom:'4px' },
  input:      { width:'100%', padding:'9px 12px', border:'1px solid #ddd', borderRadius:'6px', fontSize:'14px' },
  select:     { width:'100%', padding:'9px 12px', border:'1px solid #ddd', borderRadius:'6px', fontSize:'14px' },
  inputSm:    { width:'100%', padding:'6px 8px', border:'1px solid #ddd', borderRadius:'4px', fontSize:'13px' },
  infoCliente:{ display:'flex', gap:'2rem', marginTop:'1rem', padding:'10px', background:'#f9f9f9', borderRadius:'6px', fontSize:'13px', color:'#555' },
  tabla:      { width:'100%', borderCollapse:'collapse', fontSize:'13px' },
  theadRow:   { background:'#1a1a2e' },
  th:         { padding:'10px 8px', color:'#c8a951', textAlign:'left', fontWeight:'600' },
  row:        { borderBottom:'1px solid #f0f0f0' },
  td:         { padding:'8px', verticalAlign:'middle' },
  itemImg:    { width:'60px', height:'60px', objectFit:'cover', borderRadius:'6px', border:'1px solid #ddd' },
  sinImg:     { width:'60px', height:'60px', background:'#f5f5f5', borderRadius:'6px', display:'flex', alignItems:'center', justifyContent:'center', color:'#ccc', fontSize:'18px' },
  btnEliminar:{ background:'#fee', color:'#c00', border:'1px solid #fcc', borderRadius:'4px', padding:'4px 8px' },
  btnOrden:   { background:'#f0f0f0', border:'1px solid #ddd', borderRadius:'3px', fontSize:'10px', lineHeight:'1', padding:'2px 4px', cursor:'pointer' },
  btnAgregar: { marginTop:'1rem', background:'#f0f0f0', border:'1px solid #ddd', borderRadius:'6px', padding:'8px 16px', fontSize:'13px' },
  textarea:   { width:'100%', padding:'9px', border:'1px solid #ddd', borderRadius:'6px', fontSize:'13px', resize:'vertical' },
  totalRow:   { display:'flex', justifyContent:'space-between', padding:'8px 0', borderBottom:'1px solid #f0f0f0', fontSize:'14px' },
  totalFinal: { display:'flex', justifyContent:'space-between', padding:'12px 0', fontSize:'18px', fontWeight:'700', color:'#1a1a2e', marginTop:'8px' },
  tipoSelector: { display:'flex', gap:'10px' },
  tipoBtn:      { flex:1, padding:'12px', border:'1px solid #ddd', borderRadius:'8px', background:'#fff', color:'#666', cursor:'pointer', fontSize:'14px', fontWeight:'600' },
  tipoBtnActivo:{ flex:1, padding:'12px', border:'2px solid #c8a951', borderRadius:'8px', background:'#fff8ed', color:'#c8a951', cursor:'pointer', fontSize:'14px', fontWeight:'700' },
};